import React from 'react'
import { outlineButtonStyle } from '../styles/formStyles'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { Grid } from '@material-ui/core'
import classnames from 'classnames'
import { useTranslation } from 'react-i18next'

import HeerosIsNowFinago from '../assets/heeros_is_now_finago.png'
import ProductPills from '../assets/product-pills.svg'

const HeerosIsNowFinagoStyle = { width: '300px', maxWidth: '100%', height: 'auto', margin: '20px' }
const ProductPillsStyle = { maxWidth: '100%', height: 'auto', marginTop: '20px' }
const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
    background: '#fff'
  },
  fullHeight: {
    minHeight: '100%'
  },
  imageStyles: {
    minHeight: '100%',
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  contentSection: {
    padding: theme.spacing(3)
  },
  imageSection: {
    background: 'linear-gradient(135deg, #544BFF, #51FFDC)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(10) + 'px'
  },
  logoContainer: {
    alignSelf: 'flex-start'
  },
  logo: {
    height: theme.typography.fontSize * 1.5
  },
  contentContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 2,
    flexDirection: 'column',
    [theme.breakpoints.up('lg')]: {
      width: '25vw'
    },
    [theme.breakpoints.down('sm')]: {
      width: '80vw'
    }
  }
}))

const MainLayout = props => {
  const classes = useStyles()
  const { t, i18n } = useTranslation()
  const marketingLink = i18n?.language === 'fi-FI' ? 'https://www.heeros.com/blogi/heeros-on-nyt-osa-finagoa' : 'https://www.heeros.com/en/blog/heeros-is-now-part-of-finago'
  const handleLinkClick = () => {
    window.open(marketingLink, '_blank', 'noopener,noreferrer')
  }

  return (
    <div className={classes.root}>
      <Grid container className={classes.fullHeight}>
        <Grid
          item
          md={4} lg={4} xl={4} xs={12} sm={12}
          className={classnames(classes.fullHeight, classes.contentSection)}
        >
          <Grid container direction='column' alignItems='center' className={classes.fullHeight}>
            <Grid item className={classes.contentContainer}>
              {props.children}
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          md={8} lg={8} xl={8} xs={12} sm={12}
          className={classes.imageSection}
        >
          <div>
            <img
              style={HeerosIsNowFinagoStyle}
              src={HeerosIsNowFinago}
              alt=''
              data-test='marketing-image'
            />
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
              <button
                type='button'
                style={{
                  ...outlineButtonStyle
                }}
                data-test='marketing-image-button'
                onClick={handleLinkClick}
              >
                {t('marketing.readMore')}
              </button>
            </div>
          </div>
          <img
            style={ProductPillsStyle}
            src={ProductPills}
            alt=''
            data-test='marketing-image2'
          />
        </Grid>
      </Grid>
    </div>
  )
}

MainLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]).isRequired
}

export default MainLayout
